// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14 10V12C14 13.1 13.1 14 12 14H4C2.9 14 2 13.1 2 12V10',
  'M8 10.25V2M5.04 4.96L8 2L10.96 4.96',
];
